/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useCallback, useEffect } from 'react';
import { Button, ContentFrame, LayoutContent, LayoutContentCenter, LayoutControls, Typography, } from '@pinwheel/origami';
import { useAppDispatch } from '../../state';
import { setAdpAuth } from '../../state/slices/slice-adp-direct';
import useLinkNavigate from '../../hooks/useLinkNavigate';
import TermsOfService from '../../TermsOfService';
import { useGetLocalizedString } from '../../hooks/useGetLocalizedString';
import { useOpts } from '../../context';
import redirectToADPImage from '../../assets/redirect-to-adp.svg';
import { ScreenTitleHeader } from '../../components/ScreenTitleHeader';
var TemplateADPIframe = function (_a) {
    var linkApiResponse = _a.linkApiResponse;
    var navigate = useLinkNavigate();
    var dispatch = useAppDispatch();
    var getLocalizedString = useGetLocalizedString();
    var linkTokenPayload = useOpts().linkTokenPayload;
    var orgName = linkTokenPayload === null || linkTokenPayload === void 0 ? void 0 : linkTokenPayload.orgName;
    var skipIntroScreen = linkTokenPayload === null || linkTokenPayload === void 0 ? void 0 : linkTokenPayload.skipIntroScreen;
    var handleContinue = useCallback(function () {
        dispatch(setAdpAuth(linkApiResponse.template.iframeAuthData));
        navigate('/adp_iframe');
    }, [dispatch, linkApiResponse.template.iframeAuthData, navigate]);
    // Auto-navigate to ADP iframe when intro screen is skipped
    useEffect(function () {
        if (!skipIntroScreen) {
            handleContinue();
        }
    }, [handleContinue, skipIntroScreen]);
    if (!skipIntroScreen) {
        return null;
    }
    return (React.createElement(ContentFrame, null,
        React.createElement(LayoutContent, null,
            React.createElement(LayoutContentCenter, { sx: { textAlign: 'center' } },
                React.createElement("img", { src: redirectToADPImage, alt: "Redirecting to ADP" }),
                React.createElement(ScreenTitleHeader, { variant: "header", as: "h2", align: "center", weight: "bold" }, getLocalizedString('REDIRECTING_YOU_TO_ADP')),
                React.createElement(Typography, { variant: "caption" }, getLocalizedString('ADP_REDIRECT_INTERSTITIAL', [orgName])))),
        React.createElement(LayoutControls, null,
            React.createElement(TermsOfService, null),
            React.createElement(Button, { eventId: "ADP-interstitial-continue", onClick: handleContinue }, getLocalizedString('CONTINUE')))));
};
export default TemplateADPIframe;
